import React, { useContext, useEffect, useState, useMemo } from "react";
import { addAnnotationApi } from "../../service/MasterService";
// import './AddAnnotation.css';
import { useTranslation } from "react-i18next";
import {DefaultButton, PrimaryButton, TextField } from "@fluentui/react";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { AuthRoutes } from "../../constants/Constants";

const AddAnnotation = () => {
  const [annotationName, setAnnotationName] = useState([]);
  const [annotationColor, setAnnotationColor] = useState('#d03939');
  // const [loading,setLoading] = useState(true);
  // const { token, authenticate, authenticated } = useContext(userContext);
   const [t, i18n] = useTranslation();

  const breadCrumbItems = [
    {
      text: "Annotation",
      key: "annotation",
      href: AuthRoutes.ANNOTATION,
    },
    {
      text: "Add Annotation",
      key: "add-annotation",
    },
  ];

  const addAnnotationApiFunc = async () => {
    let payload = {
      "name": annotationName,
      "color": annotationColor//moto?
    }
    if (true) {
      const response = await addAnnotationApi(payload);
    }
  };

  const handleCancel = () =>{
    //go back to annotation list
  }

  return (
    <>
      <div id="add-container" style={{ padding: "20px 20px" }}>
        <div className="breadCrumb">
          <CustomBreadCrumb items={breadCrumbItems} />
        </div>
        <div id="main" className="form-div">
          <div className="form-section">
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl3">
                    <p className="form-field-key">Annotation Name</p>
                    <div className="form-field-value">
                      <TextField
                        name="annotationName"
                        placeholder="Annotation Name"
                        onChange={e => setAnnotationName(e.target.value)}
                        value={annotationName}
                      />
                    </div>
                  </div>
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl3">
                    <p className="form-field-key">Annotation Color</p>
                    <div className="form-field-value">
                      <TextField
                        name="annotationColor"
                        placeholder="Annotation Color"
                        value={annotationColor}
                      />
                    </div>
                    <input
                        name="annotationColorPicker"
                        onChange={e => setAnnotationColor(e.target.value)}
                        value={annotationColor}
                        type="color"
                      />
                  </div>
                </div>
                </div>
          </div>
          <div id="btns" style={{marginTop: "30px", paddingLeft:"8px"}}>
          <PrimaryButton 
              text="Save"
              style={{
                marginRight:"10px"
              }}
              onClick={addAnnotationApiFunc}
            />
            <DefaultButton 
              text="Cancel"
              style={{
                marginRight:"10px"
              }}
              onClick={handleCancel}
            />
          </div>
        </div>
        </div>
    </>
  );
};

export default AddAnnotation;
